import {Component, Input} from '@angular/core';
import {Message} from '../../../contracts/message.interface';

@Component({
  standalone: true,
  selector: 'app-message-document',
  imports: [],
  templateUrl: './message-document.component.html',
  styleUrl: './message-document.component.scss'
})
export class MessageDocumentComponent {
  @Input() message!: Message;

  getMediaUrl(message: Message): any | undefined {
    if (message.mediaUrl) {
      return message.mediaUrl;
    } else if (message.attachment) {
      return message.attachment;
    } else if (message.id) {
      return message.id;
    }
    return undefined;
  }

  openDocument(message: Message) {
    const url = this.getMediaUrl(message);
    window.open(url, '_blank');
  }
}
